// extracted by mini-css-extract-plugin
module.exports = {"aboutBanner":"PagesBanner_aboutBanner__1QItd","pageBanner":"PagesBanner_pageBanner__2gX6A","image":"PagesBanner_image__2C8gC"};